import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const DownArrowIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17">
        <path
            d="M3.91424 5.24951C3.02333 5.24951 2.57716 6.32665 3.20713 6.95662L7.29292 11.0424C7.68344 11.4329 8.31661 11.4329 8.70713 11.0424L12.7929 6.95662C13.4229 6.32665 12.9767 5.24951 12.0858 5.24951H3.91424Z"
            fillOpacity="0.56"
        />
    </svg>,
    'DownArrow'
);

export default DownArrowIcon;
